export const decisionCodeToStatus = {
  'Awaiting Review': 803370000,
  'Requested Additional Information': 803370001,
  Declined: 803370002,
  'Pre-Approved': 803370004,
  Approved: 803370003,
};

export const CREDIT_SUB_STAGE_OPTIONS = [
  { value: 804790000, label: 'Submitted to Lender' },
  { value: 804790001, label: 'Lender Reviewing' },
  { value: 804790002, label: 'Lender - Additional Info Requested' },
  { value: 804790003, label: 'Lender Approved' },
  { value: 804790004, label: 'Lender Declined' },
  { value: 804790005, label: 'Dealer Accepted' },
  { value: 804790006, label: 'Dealer Cancelled' },
  { value: 804790007, label: 'Docs Out' },
  { value: 804790008, label: 'Docs in' },
  { value: 804790009, label: 'Funding Review' },
  { value: 804790010, label: 'Funding Items Requested' },
  { value: 804790011, label: 'Customer Cancelled' },
  { value: 804790013, label: 'Lender Pre-Approved' },
  { value: 804790020, label: 'Funded' },
];
